import { MagnifyPlusOutlineIcon } from './MagnifyPlusOutlineIcon';

/**
 * author: Google
 * id 521EC414-ECAD-435D-BAE3-4CF772659845
 * name magnify-plus-outline
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/magnify-plus-outline.svg
 * tags
 * - Geographic Information System 
 */
export const MagnifyAddOutlineIcon = MagnifyPlusOutlineIcon;
export default MagnifyAddOutlineIcon